const regionsMap = document.querySelector('.regions-map');

if (regionsMap) {
  const activeContent = regionsMap.querySelector('.regions-map__content.is-active');
  const regionId = activeContent.getAttribute('data-region-id');
  const targetMapRegion = regionsMap.querySelector(`#${regionId} .land`);
  targetMapRegion.classList.add('is-active');

  const allMapRegions = regionsMap.querySelectorAll('.land-wrapper');

  allMapRegions.forEach((mapRegion) => {
    mapRegion.addEventListener('click', () => {
      const activeMapRegion = regionsMap.querySelector('.land.is-active');
      const activeContentClick = regionsMap.querySelector('.regions-map__content.is-active');
      activeContentClick.classList.remove('is-active');
      activeMapRegion.classList.remove('is-active');

      const targetRegionId = mapRegion.getAttribute('id');
      const targetRegionLand = mapRegion.querySelector('.land');
      const targetContent = regionsMap.querySelector(`[data-region-id="${targetRegionId}"]`);
      targetContent.classList.add('is-active');
      targetRegionLand.classList.add('is-active');
    });
  });
}
